import React from 'react';
import { isEmpty } from 'lodash';
import { generateTaxonomyQuery } from '../../utils/constants/taxonomy';

import TSTaxonomy from '../../utils/typesense/taxonomy';
import { ITSTaxonomyProductQueryVars } from '../../utils/typesense/types/taxonomy';
import TaxonomyItemPage from '../../components/content/TaxonomyItemPage';
import { GetStaticProps } from 'next';
import { TaxonomyPathsParams } from '../../utils/types/taxonomy';
import cyohProductData from '../../data/cyohProductData';

export async function getStaticPaths() {
  if (
    process.env.SKIP_BUILD_STATIC_GENERATION == 'true' ||
    process.env.NEXT_PUBLIC_MAINTENANCE == 'true'
  ) {
    return {
      paths: [],
      fallback: true,
    };
  }
  const paths = await TSTaxonomy.buildStaticPathParams(1);

  return {
    paths: paths,
    fallback: 'blocking',
  };
}

export default TaxonomyItemPage;

export const getStaticProps: GetStaticProps = async (context) => {
  const { taxonomyFrontendSlug, taxonomyItemSlug } =
    context.params as TaxonomyPathsParams['params'];

  let showPerfectGiftHelper = false;
  let guideKey: string = '';

  if (taxonomyItemSlug == 'fathers-day') {
    showPerfectGiftHelper = true;
    guideKey = '6d5b4f44-42d2-4e82-8815-08d8381505b1';
  }

  if (taxonomyItemSlug == 'mothers-day') {
    showPerfectGiftHelper = true;
    guideKey = '03db33f9-8005-4f89-4b89-08d7d5c69943';
  }

  if (taxonomyItemSlug == 'christmas-gift-hampers') {
    showPerfectGiftHelper = true;
    guideKey = '16a5a0c6-ebbc-4c18-4aab-08d889c81287';
  }

  const taxQuery = generateTaxonomyQuery(taxonomyFrontendSlug);
  if (isEmpty(taxQuery)) {
    return { notFound: true };
  }

  const wpTaxSlug =
    TSTaxonomy.taxonomyUrlSlugToWpTaxonomySlug(taxonomyFrontendSlug);

  const taxonomyData = await TSTaxonomy.getPageData(
    wpTaxSlug,
    taxonomyItemSlug,
  );

  const defaultQueryVars = TSTaxonomy.getDefaultTsQueryVars();
  let taxonomyProductQueryVars: ITSTaxonomyProductQueryVars = {
    ...defaultQueryVars,
    taxonomySlug: wpTaxSlug,
    termSlug: taxonomyItemSlug,
  };

  if (process.env.NEXT_PUBLIC_DISABLE_ADDONS !== 'true') {
    taxonomyProductQueryVars = {
      ...taxonomyProductQueryVars,
      pinnedHits: cyohProductData.id + ':2', // Pin the product to results in position 2
    };
  }
  const tsFetchedData = await TSTaxonomy.getProducts(taxonomyProductQueryVars);

  const popularProducts = await TSTaxonomy.getPopularProducts(
    wpTaxSlug,
    taxonomyItemSlug,
  );

  return {
    props: {
      taxonomyDescription: taxonomyData?.description ?? '',
      fullHead: taxonomyData?.seoFullHead ?? '',
      pageSchemaCode: taxonomyData?.pageSchemaCode ?? '',
      categoryName: taxonomyData?.name ?? '',
      popular: popularProducts ?? [],
      hero: {
        sourceUrl: taxonomyData?.bannerThumbnail ?? '',
        name: taxonomyData?.name ?? '',
        bannerText: taxonomyData?.bannerText ?? '',
      },
      tsFetchedData: tsFetchedData,
      showPerfectGiftHelper: showPerfectGiftHelper,
      guideKey: guideKey,
    },
    revalidate: 43200, // Refresh the generated page every 12 hours,
  };
};
